import d from "./index.es242.js";
function g(o) {
  var r = o.sheetId, a = o.orientation, t = "";
  if (a) {
    var e = 0.7, n = 0.7, c = 0.75, i = 0.75, v = 0.3, p = 0.3;
    t += "<pageMargins", t += ' left="'.concat(e, '"'), t += ' right="'.concat(n, '"'), t += ' top="'.concat(c, '"'), t += ' bottom="'.concat(i, '"'), t += ' header="'.concat(v, '"'), t += ' footer="'.concat(p, '"'), t += "/>";
  }
  if (a) {
    var u = 9;
    t += "<pageSetup", t += ' paperSize="'.concat(u, '"'), t += ' orientation="'.concat(d(a), '"'), t += ' r:id="rId'.concat(r, '"'), t += "/>";
  }
  return t;
}
export {
  g as default
};
//# sourceMappingURL=index.es268.js.map
